/**
 * Tabs another module mounts into the docked station screen (M3 plan R22f, §7 item 3): the Reach's station
 * services (Charts, Parts, Home) show beside M2's own tabs. The screen gives a tab an element and a host; the tab
 * renders plain DOM into it and returns its unmount. Its `<button>`s join the focus model in DOM order, so the
 * keyboard and the pad reach them like M2's own items. Types and a DOM helper only.
 */
import type { TabReachSignals } from './models/stationTabs'

/** What the station screen offers a mounted tab. */
export interface ExternalTabHost {
  /** The tab changed its buttons: the screen re-reads them (focus count, handlers). */
  refresh(): void
  /** The tab asks to close: the screen goes back to its own tab. */
  close(): void
}

export interface ExternalTab {
  readonly id: string
  readonly title: string
  /** Renders into `el`; returns the unmount. */
  mount(el: HTMLElement, host: ExternalTabHost): () => void
}

export interface ExternalTabSource {
  /** The extra tabs of the docked station `stationId`, in order (none when it has none). */
  list(stationId: string): readonly ExternalTab[]
  /**
   * CL-6 (core-loop plan §4): the Reach's state the tab promotion rules read at `stationId` (chart data this station
   * buys, fines or bounties, a corporation) and the Wire's unread count; read-only. Absent or null = all off.
   */
  signals?(stationId: string): TabReachSignals | null
}

/** The buttons a mounted tab offers the focus model, in DOM order. */
export function externalButtons(el: ParentNode): HTMLButtonElement[] {
  return Array.from(el.querySelectorAll('button'))
}
